var _g, _path, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextjs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 260,
    viewBox: "0 0 261 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_303_17118)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.724,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.224,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#878787"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_303_17118",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 116,
    width: 101,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.276 116.217H80.2761V136.517H180.276V116.217Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_303_17118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.756 116.217H164.176V119.437H157.276V136.357H153.806V119.437H146.806L146.756 116.217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.106 116.217V119.437H104.106V124.617H115.376V127.827H104.146V133.137H118.146V136.357H100.686V119.437V116.217H118.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.806 116.217H122.276L138.476 136.367H143.016L134.916 126.307L142.996 116.217H138.476L132.646 123.497L126.806 116.217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.446 130.607L129.176 127.797L122.276 136.377H126.816L131.446 130.607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.806 136.357L84.5961 116.217H80.2761V136.347H83.7261V120.517L96.4661 136.357H100.806Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.946 136.217C164.826 136.221 164.706 136.199 164.594 136.155C164.482 136.11 164.381 136.043 164.296 135.957C164.131 135.787 164.038 135.56 164.038 135.322C164.038 135.085 164.131 134.857 164.296 134.687C164.47 134.518 164.704 134.425 164.946 134.427C165.065 134.426 165.182 134.449 165.292 134.493C165.402 134.538 165.502 134.604 165.586 134.687C165.672 134.768 165.74 134.866 165.787 134.974C165.833 135.083 165.857 135.199 165.856 135.317C165.858 135.479 165.817 135.637 165.736 135.777C165.65 135.909 165.533 136.019 165.396 136.097C165.26 136.179 165.104 136.221 164.946 136.217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.846 127.747H172.376V133.647C172.388 134.137 172.267 134.621 172.026 135.047C171.789 135.44 171.441 135.753 171.026 135.947C170.576 136.159 170.083 136.266 169.586 136.257C169.135 136.26 168.689 136.168 168.276 135.987C167.87 135.837 167.521 135.565 167.276 135.207C167.034 134.821 166.912 134.372 166.926 133.917H168.466C168.461 134.121 168.513 134.322 168.616 134.497C168.711 134.663 168.854 134.795 169.026 134.877C169.212 134.969 169.418 135.014 169.626 135.007C169.847 135.016 170.066 134.961 170.256 134.847C170.429 134.74 170.565 134.583 170.646 134.397C170.745 134.16 170.793 133.904 170.786 133.647L170.846 127.747Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.676 130.057C178.664 129.89 178.614 129.729 178.529 129.585C178.444 129.44 178.326 129.318 178.186 129.227C177.856 129.016 177.468 128.911 177.076 128.927C176.793 128.916 176.51 128.964 176.246 129.067C176.039 129.149 175.856 129.284 175.716 129.457C175.598 129.62 175.532 129.816 175.526 130.017C175.52 130.177 175.566 130.335 175.656 130.467C175.739 130.602 175.852 130.715 175.986 130.797C176.134 130.888 176.291 130.962 176.456 131.017L176.976 131.177L177.776 131.367C178.094 131.441 178.405 131.542 178.706 131.667C178.994 131.79 179.263 131.951 179.506 132.147C179.74 132.334 179.931 132.57 180.066 132.837C180.213 133.132 180.285 133.458 180.276 133.787C180.282 134.249 180.15 134.702 179.896 135.087C179.616 135.477 179.231 135.779 178.786 135.957C177.669 136.364 176.444 136.364 175.326 135.957C174.867 135.779 174.47 135.47 174.186 135.067C173.904 134.651 173.751 134.16 173.746 133.657H175.276C175.291 133.924 175.389 134.179 175.556 134.387C175.726 134.582 175.943 134.73 176.186 134.817C176.466 134.912 176.76 134.959 177.056 134.957C177.356 134.963 177.655 134.912 177.936 134.807C178.17 134.723 178.377 134.578 178.536 134.387C178.677 134.211 178.755 133.993 178.756 133.767C178.76 133.565 178.689 133.369 178.556 133.217C178.407 133.061 178.226 132.939 178.026 132.857C177.764 132.756 177.497 132.669 177.226 132.597L176.226 132.357C175.616 132.224 175.047 131.946 174.566 131.547C174.362 131.367 174.202 131.142 174.096 130.892C173.991 130.641 173.943 130.369 173.956 130.097C173.949 129.634 174.093 129.181 174.366 128.807C174.652 128.419 175.039 128.118 175.486 127.937C175.991 127.721 176.537 127.616 177.086 127.627C177.632 127.615 178.175 127.72 178.676 127.937C179.103 128.124 179.472 128.421 179.746 128.797C180.01 129.16 180.15 129.598 180.146 130.047L178.676 130.057Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_303_17118",
    x: 0.723999,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_303_17118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_303_17118",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjs);
export default __webpack_public_path__ + "static/media/nextjs.148fe4363f5cb2e97c9a1e7327a2d5e1.svg";
export { ForwardRef as ReactComponent };